// extracted by mini-css-extract-plugin
module.exports = {"shared":"\"../../../shared.module.css\"","md":"768px","lg":"992px","categoryHeaderContainer":"CategoryHeader_categoryHeaderContainer__2L95w"};